class testAudioContext {
  constructor() {
    // 创建音频上下文
    this.audioContext = new (window.AudioContext || window.webkitAudioContext)()
    // this.oscillator = this.audioContext.createOscillator()
    // this.oscillator.channelInterpretation = 'discrete'
    this.audioStreamLeft = null
    this.audioStreamRight = null,
    this.stream = null,
    this.leftGain = null,
    this.rightGain = null
  }

  leftRightTrack (audioTrack, key) {
    if (this.audioContext.state === 'suspended') this.audioContext.resume()
      const mediaStream = new MediaStream()
      mediaStream.addTrack(audioTrack)
      this.stream = this.audioContext.createMediaStreamSource(mediaStream)

      // 创建 ChannelMergerNode
      const merger1 = this.audioContext.createChannelMerger(2)
      const merger2 = this.audioContext.createChannelMerger(2)

      // 创建增益节点用于调节音量
      const Gain = this.audioContext.createGain()

      const splitter = this.audioContext.createChannelSplitter(2)

      const pannerOptions = { pan: 0 }
      const pannerLeft = new StereoPannerNode(this.audioContext, pannerOptions)
      const pannerRight = new StereoPannerNode(this.audioContext, pannerOptions)

      pannerLeft.pan.value = 0
      pannerRight.pan.value = -1

      // 连接音频节点
      this.stream.connect(Gain)
      Gain.connect(splitter)
      const gainNodeLeft = this.audioContext.createGain()
      const gainNodeRight = this.audioContext.createGain()

      // 连接增益节点到通道合并器
      splitter.connect(gainNodeLeft, 1)
      splitter.connect(gainNodeRight, 1)

      // 连接合并器到音频输出
      gainNodeLeft.gain.setValueAtTime(0, this.audioContext.currentTime)
      gainNodeRight.gain.setValueAtTime(0, this.audioContext.currentTime)
      gainNodeLeft.gain.value = 0
      gainNodeRight.gain.value = 1
    
      gainNodeLeft.connect(merger1, 0, 0)
      gainNodeRight.connect(merger2, 0, 1)
    
      merger1.connect(pannerLeft).connect(this.audioContext.destination)
      merger2.connect(pannerRight).connect(this.audioContext.destination)
  }

  controlGain (value) {
    this.leftGain.gain.setValueAtTime(value, this.audioContext.currentTime)
  }

  addAudioTrack  (audioTrack) {
    if (this.audioContext.state === 'suspended') this.audioContext.resume()
    const audioStream = new MediaStream()
    audioStream.addTrack(audioTrack)
    this.audioMediaStream = this.audioContext.createMediaStreamSource(audioStream)

    // 创建通道分离器，假设视频音频是 2 声道
    const channelSplitter = this.audioContext.createChannelSplitter(2)

    // 创建增益节点用于调节音量
    this.leftGain = this.audioContext.createGain()
    this.rightGain = this.audioContext.createGain()

    // 设置左右声道的音量
    // this.leftGain.gain.value = 1 // 左声道音量
    // this.rightGain.gain.value = 0 // 右声道音量

    this.leftGain.gain.setValueAtTime(0.3, this.audioContext.currentTime)
    this.rightGain.gain.setValueAtTime(1, this.audioContext.currentTime)

    //创建通道合并器
    const channelMerger = this.audioContext.createChannelMerger(2)

    // 连接节点
    this.audioMediaStream.connect(channelSplitter)
    channelSplitter.connect(this.leftGain, 0) // 获取左声道
    channelSplitter.connect(this.rightGain, 1) // 获取右声道

    // 连接增益节点到通道合并器
    this.leftGain.connect(channelMerger, 0, 0) // 左声道
    this.rightGain.connect(channelMerger, 0, 1) // 右声道

    // 连接合并器到音频输出
    channelMerger.connect(this.audioContext.destination)

  }

  testStereoPanner (audioTrack) {
    if (this.audioContext.state === 'suspended') this.audioContext.resume()
    const audioStream = new MediaStream()
    audioStream.addTrack(audioTrack)
    const mediaStream = this.audioContext.createMediaStreamSource(audioStream)
    // 创建 ChannelSplitterNode 分离声道
    const splitterNode = this.audioContext.createChannelSplitter(2)
    // 创建 ChannelMergerNode 合并声道
    const mergerNode = this.audioContext.createChannelMerger(2)
    // 创建一个 StereoPannerNode 用于声道分离
    const pannerNode = this.audioContext.createStereoPanner()
    pannerNode.pan.value = 0.98
    mediaStream.connect(splitterNode)
    splitterNode.connect(mergerNode, 1, 1)
    mergerNode.connect(pannerNode)
    pannerNode.connect(this.audioContext.destination)
  }
}

export default testAudioContext
